export default __webpack_public_path__ + "static/media/sort_desc.f9cabd57.webp";